import {
  useWSModal,
  WSActions,
  WSAlert,
  WSButton,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import { PayeeEngagement } from "@wingspanhq/wingspan-api-sdk";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";
import { useHistory } from "react-router-dom";

export interface ArchivalNotAllowedModalProps {
  payeeId: string;
  payeeName: string;
  engagement: PayeeEngagement;
  onClose: () => void;
}

export const ArchivalNotAllowedModal: React.FC<
  ArchivalNotAllowedModalProps
> = ({ payeeId, payeeName, engagement, onClose }) => {
  const history = useHistory();

  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Assignment name"
            value={engagement.engagementName}
          />
          <FieldView label="Contractor name" value={payeeName} />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Assignment cannot be archived when:"
      >
        Outstanding invoices exist - they must be canceled or paid out first
        before the assignment can be archived.
        <WSElement>
          <WSButton.Link
            rightIcon="chevron-right"
            onClick={() => {
              history.push(`/member/invoices/payables/all?payeeId=${payeeId}`);
            }}
          >
            View invoices
          </WSButton.Link>
        </WSElement>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useArchivalNotAllowedModal = () => {
  return useWSModal(ArchivalNotAllowedModal, {
    title: "Assignment cannot be archived",
    size: "M"
  });
};
